module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./LineChart.js"));
	}, "LineChart");
}